import {takeEvery, put, call, all, fork} from "redux-saga/effects"

import {
  SELECT_MODAL_LIST,
  SELECT_MODAL_SELECTED,
  SELECT_MODAL_UPDATE,
} from "./actionTypes"

import {
  selectModalListSuccess,
  selectModalListError,
  selectModalSelectedSuccess,
  selectModalSelectedError,
  selectModalUpdateSuccess,
  selectModalUpdateError,
} from "./actions"

function* selectModalList({payload: data}) {
  try {
    const response = yield call(data.apiList, data)
    yield put(selectModalListSuccess(response))
  } catch (error) {
    yield put(selectModalListError(error))
  }
}

function* selectModalSelected({payload: data}) {
  try {
    const response = yield call(data.apiSelected, data)
    yield put(selectModalSelectedSuccess(response))
  } catch (error) {
    yield put(selectModalSelectedError(error))
  }
}

function* selectModalUpdate({payload: data}) {
  try {
    const response = yield call(data.apiUpdate, data)
    yield put(selectModalUpdateSuccess(response))
  } catch (error) {
    yield put(selectModalUpdateError(error))
  }
}

export function* watchSelectModalList() {
  yield takeEvery(SELECT_MODAL_LIST, selectModalList);
}

export function* watchSelectModalSelected() {
  yield takeEvery(SELECT_MODAL_SELECTED, selectModalSelected);
}

export function* watchSelectModalUpdate() {
  yield takeEvery(SELECT_MODAL_UPDATE, selectModalUpdate);
}

function* selectModalSaga() {
  yield all([
    fork(watchSelectModalList),
    fork(watchSelectModalSelected),
    fork(watchSelectModalUpdate),
  ]);
}

export default selectModalSaga
